import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { NavParams, ModalController,Platform ,IonInfiniteScroll} from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { MessageclientService } from 'src/service/messageclient.service';
import { ActivatedRoute } from '@angular/router';
import { WebParameterContext,WebResponesContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-codeless-salse',
  templateUrl: './codeless-salse.page.html',
  styleUrls: ['./codeless-salse.page.scss'],
})

export class CodelessSalsePage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  dataArrayList: Array<any> = [];
  dataArrayListItems: any={};
  
  dataArray: Array<any> = []; //分类主题
  PageNumber:number=1;//当前第几页 默认第一页
  step: number = 0;
  AId : any; 
  num: number = 0; // 选中的第几个
  apiObj = {
    status: false,
    msg: ''
};//接口状态
loading: boolean = false;//加载效果
isSearch:boolean = true;//获取是否有查询条件
RecordCount: Number = 0;//列表总数量
searchValue:any="";//查询条件
 webRespone:WebResponesContext = new WebResponesContext();//返回结果处理对象
 checkedAll:boolean=false;//判断是权限or反选；
 typeID:any=null;//存储类型ID，默认加载类型下标第一个；
 typeCode:any = null;// 存储类型CodeID
 messageShow :boolean = false;// 选中消息提示
 checkItem:any={};//获取选中的对象
  constructor(
    public modalController: ModalController,
    public  navParams: NavParams,
    public http:HttpCustomerService,
    public com:CommonService,
    public msg:MessageclientService,
    private activaRouter: ActivatedRoute
  ) { }

  ngOnInit() {
    let that =this;
    that.LoadData(1);
  
   
  }
  serarEvent(e,type:string = 'type'){ 
    const that=this;
    if(e.keyCode == 13 || type=='search'){
      that.LoadData(1);
    }
  }
  // 取消按钮
  dismissModal() {
    const that=this;
    that.webRespone.Status=new Array<any>();
    that.webRespone.ResponseMessage.Success=true;
    that.modalController.dismiss({
      "result":  that.webRespone,
      "checked":that.checkedAll
    });
  }
  btn_change(num,item){
    const that=this;
    if(that.step == num){
      that.step = 0;
    }else{
      that.step = num;
    }
    that.typeCode = item["brandCode"];
    if(!that.dataArrayListItems[that.typeCode]){
      that.dataArrayListItems[that.typeCode]=item.products||[];
    }
  }
  /**
   * 请求数据列表
   * @param PageNumber 当前页数
   */
  LoadData(PageNumber){
  let that = this;
  that.PageNumber = PageNumber;
  if (PageNumber == 1) {
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    that.dataArrayList = [];
    that.dataArrayListItems={};
  }
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let id = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  body.ConfigName="GetTBProductCheckAndBrand";
  body.OpType = "query";
  body.ConfigType = "view";
  // body.RowsPerPage = app.RowsPerPage;
  body.PageNumber = PageNumber;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = "publicselection";
  body.Client.ClientType = 2;
  body.RequestBody={};
  if(that.searchValue){
    body.RequestBody["Name"]=that.com.LikeSearch(that.searchValue);
  }
  // let orderDate = that.com.BetweenDate(that.month+" 00:00:00",that.month+" 23:59:59");
  body.RequestBody = JSON.stringify(body.RequestBody);
  that.http.post(app.DEFAULTURL, body).then(data => {
    // console.log(data)
    /****判断是否第一页begin****/
    if(PageNumber == 1){
      that.dataArrayList = [];
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
    }else{
      if( that.infiniteScroll){
        that.infiniteScroll.complete();
      }
    }
    /****判断是否第一页end****/
    if (data.ResponseMessage.Success) {
      that.dataArrayList=data.Status.Datas||[];
      that.typeCode=that.dataArrayList[0].brandCode;
      if(that.dataArrayList.length>0){
        that.dataArrayList.forEach(item=>{
          item.products.forEach(p => {
            if(that.checkItem.find(y=>y.id==p.a_FK_TBProductInformation_ID)){
              p.Num=that.checkItem.find(y=>y.id==p.a_FK_TBProductInformation_ID).num||null;
            }else{
              p.Num=null;
            }
            p.brand=item.brand;
            p.checked = false;
          });
        })
        that.dataArrayListItems[that.typeCode]=that.dataArrayList[0].products||[];
      }
      /****上拉加载数据begin****/
         that.RecordCount = data.Status.RecordCount;
      if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
        // that.infiniteScroll.disabled = true;
        if( that.infiniteScroll){
          that.infiniteScroll.disabled = true;
        }
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.disabled = false;
        }
      }
      /****上拉加载数据end****/
    }else{
      // that.dataArrayList=new Array<any>();
      that.apiObj['status'] = false;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
    }

  }).catch(error => {
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading = true;
    console.log(error);
  });
}
    /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event){
    const that=this;
    if(that.typeCode){
      that.step = 0;
      that.LoadData(1);
    }
    event.target.pullMax=500;
    event.target.pullMin=100;
    event.target.complete();
  }
  /**
   * 确认事件
   */
  comfireModal() {
    const that=this;
    console.log("确认按钮");
    let ids:Array<any>=that.checkItem||[];//获取选中的id
    // let ids:Array<any>= [];//获取选中的id
    that.webRespone.Status=new Array<any>();
    that.webRespone.ResponseMessage.Success=true;
    for(var key in that.dataArrayListItems){  
      that.dataArrayListItems[key].forEach(items => {
        if(ids.find(ds=>ds.id==items.a_FK_TBProductInformation_ID)){
          if(!items.Num){
            ids.forEach((tmp,index)=>{
                if(tmp.id==items.a_FK_TBProductInformation_ID){
                  ids.splice(index,1);
                }
            })
          }else{
            ids.find(ds=>ds.id==items.a_FK_TBProductInformation_ID).Num=items.Num;
          }
        }else{
          if(items.Num){
            ids.push(items);
          }
        }
      });
    }
    if(ids.length<=0){
      that.msg.Alert("请填写产品数量");
        return;
    }
    that.webRespone.Status=ids;
    this.modalController.dismiss({
      "result": that.webRespone,
      "checked":that.checkedAll
    });
  }
  /**
   * 公共礼品选择
   * @param item 当前点击项
   */
  onInput(item,e) {
    const that=this;
    that.dataArrayListItems.filter(pt=>pt.brand==item.brand).forEach(items=>{
      if(e.target.checked){
        items.checked==!e.target.checked;
        items.checked = false;
      }
    });
    item['checked'] = !item['checked'];
    let _isCheckAll = true;
    if(that.dataArrayList.length>0){
      that.dataArrayList.forEach(ck=>{
        ck.products.forEach(check=>{
          if(!check.checked){
            // check.checked==!e.target.checked;
            // check.checked = false;
            _isCheckAll = false;
          }
        }); 
      });
    }
    if (_isCheckAll) {
      that.checkedAll = true;
    } else {
      that.checkedAll = false;
    }
    item.checked=e.target.checked;
    console.log(item,"当前的id集合：");
  }
  onInputNUm(item,event) {
    const that=this;
     if(event.target.value){
      let numvalue: any = that.com.GetNumber(event.target.value);
      setTimeout(() => {
        if (event.target.value) {
          console.log(numvalue);
          if (numvalue) {
             event.target.value = numvalue;
                item.Num = numvalue;
          } else {
            item.Num = 0;
            event.target.value = 0;
          }
        } else {
          event.target.value = null;
          item.Num = 0;
        }
        // if(item.Num){
        //   if(!item.checked){
        //     item.checked=true;
        //   }
        // }else{
        //   if(item.checked){
        //     item.checked=false;
        //   }
        // }
      },100);
     }else{
      item.Num = 0;
      // if(item.checked){
      //   item.checked=false;
      // }
     }
  }


  /**
   * 全选
   * @param e 
   */
  checkEvent(e) {
    const that=this;
    console.log("门店类型");
    that.checkedAll = !that.checkedAll;
    if (that.checkedAll) {
      that.dataArrayListItems.forEach(items => {
        items.checked=true;
      });
    } else {
      that.dataArrayListItems.forEach(items => {
        items.checked=true;
      });
    }

    
    
    
  }
 
}
